import script from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportUploadFile.vue?vue&type=script&setup=true&lang=js"

import "./ImportUploadFile.vue?vue&type=style&index=0&id=a371b4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a371b4fa"]])

export default __exports__